export default __webpack_public_path__ + "static/media/doc.c098d799.svg";